import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./assets/css/tailwind.css";
import { gameApi, authApi } from "./api";

import VueCookies from "vue-cookies-reactive";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import infiniteScroll from "vue-infinite-scroll";
import VueFullscreen from "vue-fullscreen";
import VueMeta from "vue-meta";
import userData from "./plugins/userData";
import "nprogress/nprogress.css";
import device from "vue-device-detector";


Vue.use(device);
Vue.use(infiniteScroll);
Vue.use(VueCookies);
Vue.config.productionTip = false;
Vue.prototype.$gameApi = gameApi;
Vue.prototype.$authApi = authApi;
Vue.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 20,
  newestOnTop: true,
});
Vue.use(VueFullscreen);
Vue.use(VueMeta);
Vue.use(userData, store);

//components
import AppLayout from "./layouts/AppLayout.vue";
import MaintenanceLayout from "./layouts/MaintenanceLayout.vue";
import UserNav from "./components/navigations/UserNav.vue";
import Error from "./components/dialogs/Error.vue";
Vue.component("app-error", Error);
Vue.component("app-layout", AppLayout);
Vue.component("maintenance-layout", MaintenanceLayout);
Vue.component("user-nav", UserNav);

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount("#app");
